import { object, number, string } from '@gogame/schemas';

import {
  ID,
  REQUESTED_BY,
  YOUTUBE_LINK,
  JIRA_TASK,
  DESIGNER,
  TESTED,
  PRODUCTION_TYPE,
} from 'scenes/Gallery/GalleryPage/Creatives/constants';
import { creativeValidationSchema } from 'scenes/Gallery/GalleryPage/Creatives/schemas';

export const getValidationSchema = ({
  isAllowDesigner,
  isAllowRequestedBy,
  isAllowJiraTask,
  isAllowTested,
  isAllowProductionType,
}) => {
  let schema = creativeValidationSchema.shape({
    [ID]: object().required('ID by is required'),
    [YOUTUBE_LINK]: string().url('Invalid Youtube Link'),
  });

  if (isAllowJiraTask) {
    schema = schema.shape({
      [JIRA_TASK]: string().url('Jira Task URL must be a valid URL'),
    });
  }
  if (isAllowRequestedBy) {
    schema = schema.shape({
      [REQUESTED_BY]: number().required('Requested by is required'),
    });
  }
  if (isAllowDesigner) {
    schema = schema.shape({
      [DESIGNER]: number(),
    });
  }
  if (isAllowTested) {
    schema = schema.shape({
      [TESTED]: number().required('Tested is required'),
    });
  }
  if (isAllowProductionType) {
    schema = schema.shape({
      [PRODUCTION_TYPE]: number().required('Production type is required'),
    });
  }

  return schema;
};
